module.exports = __webpack_public_path__ + "img/MD5.abb33385.svg";